import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-todo",
  "use": "icon-todo-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-todo\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M23 14.317h0V21a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h16\" /><path stroke-linecap=\"square\" d=\"M26.243 6.757l-8.486 8.486m-4.025-4.011l3.536 3.536\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol